<div class="registration-promotion-banner">
  <ng-content></ng-content>
</div>
